import { State } from './state.type';

export const stateInitializer = (): State => {
	// console.log('context: stateInitializer()');

	return {
		email: null,
		isLoading: false,
		isLoadingMessage: '',
		hasLoaded: false,
		designs: [],
		page: 0,
		pageCount: 0,
		totalCount: 0,
		isLoadingMore: false,
		index: []
	};
};
